const testimonials = [
  {
    name: "Carlos Martínez",
    service: "Grúa en carretera",
    text: "Servicio impecable. Me quedé tirado en la A-22 a las 2 de la madrugada y en menos de 40 minutos ya estaban allí. Muy profesionales y amables.",
    rating: 5,
  },
  {
    name: "María López",
    service: "Compra de furgoneta",
    text: "Compré una furgoneta Transit y estoy encantada. Me explicaron todo con detalle, el vehículo estaba en perfecto estado y el precio fue muy justo.",
    rating: 5,
  },
  {
    name: "Transportes Pirineo S.L.",
    service: "Transporte de maquinaria",
    text: "Llevamos años trabajando con GERPAT para el traslado de nuestra maquinaria agrícola. Siempre puntuales, siempre profesionales. Totalmente recomendables.",
    rating: 5,
  },
  {
    name: "Javier Sánchez",
    service: "Asistencia en carretera",
    text: "Batería muerta en pleno invierno en la montaña. Llegaron rápido, me arrancaron el coche y me acompañaron hasta el taller más cercano. Excelente trato.",
    rating: 5,
  },
  {
    name: "Ana Ferrer",
    service: "Grúa para turismo",
    text: "Accidente leve en la N-240. GERPAT gestionó todo con la aseguradora directamente. Me quitaron un peso enorme de encima en un momento muy difícil.",
    rating: 5,
  },
  {
    name: "Construcciones Monegros",
    service: "Transporte de maquinaria",
    text: "Trasladaron una excavadora de gran tonelaje sin ningún problema. Equipo muy preparado y con los permisos necesarios. Volveremos a contar con ellos.",
    rating: 5,
  },
];

export default function TestimonialsSection() {
  return (
    <section className="bg-[#1a1a1a] py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest">Opiniones</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mt-3 mb-4" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
            LO QUE DICEN NUESTROS CLIENTES
          </h2>
          <div className="w-16 h-1 bg-[#FF6B35] mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-[#252525] rounded-xl p-6 flex flex-col gap-4">
              <div className="flex gap-1">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FFC107] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-300 text-sm leading-relaxed flex-1">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3 pt-3 border-t border-white/10">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FF6B35]/20">
                  <i className="ri-user-line text-[#FF6B35]"></i>
                </div>
                <div>
                  <div className="text-white text-sm font-semibold">{t.name}</div>
                  <div className="text-gray-500 text-xs">{t.service}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
